import { render } from "./Index.vue?vue&type=template&id=f00811b2&bindings={\"slug\":\"setup\"}"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&lang=css"
script.render = render

export default script